import { isPast as isPastDateFns } from 'date-fns';

import { parseDateString } from './parseDateString';

export const isPast = (dateString) => {
  const date = parseDateString(dateString);

  return isPastDateFns(date);
};
